import { useTranslation } from "react-i18next";
import useSearchDialogForm from "../../../hooks/useSearchDialogForm";
import LoadingSpinner from "~/ui/LoadingSpinner/LoadingSpinner";
import clsx from "clsx";
import { useTabStore } from "~/stores";
import { SEARCH_TABS } from "~/types/search.types";

interface BtnSearchProps {
    isLoading: boolean;
}

const BtnSearch = (props: BtnSearchProps) => {
    const { isLoading } = props;
    const { t } = useTranslation();
    const { isFetching, totalSelectedItems, handleSearchBtnClick } = useSearchDialogForm();

    const activeTab = useTabStore(state => state.tab);
    const showTotalCount = totalSelectedItems > 0 && activeTab?.key !== SEARCH_TABS.FULL_DOCUMENTS;

    const isDisabled = isLoading || totalSelectedItems === 0;
    const btnBaseClass =
        "flex justify-center !min-w-[147px] py-2 px-4 text-center !text-base !text-stone-lightest font-medium-light !tracking-[-0.32px] !bg-salmon-primary !rounded-lg";
    const btnClass = clsx(btnBaseClass, isDisabled && "opacity-50");

    const labelWithCount = `${t("searchForm.popup.btnShowLabel")}${
        showTotalCount ? ` ${totalSelectedItems} ` : " "
    }${t("searchForm.popup.btnResultsLabel")}`;

    const btnLabel =
        totalSelectedItems === 0 ? t("searchForm.popup.btnSearchLabel") : labelWithCount;

    const btnContent = isFetching ? <LoadingSpinner /> : <span>{btnLabel}</span>;

    return (
        <button className={btnClass} disabled={isDisabled} onClick={handleSearchBtnClick}>
            {btnContent}
        </button>
    );
};

export default BtnSearch;
